import { autoinject, bindable, containerless } from 'aurelia-framework';

@containerless
@autoinject
export class DynamicTableDataView {
  @bindable header = '';
  constructor() {}
}
